import { getBookmark } from '../../graphql/queries';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const fetchBookmark = async (authMode) => {
  // Parse the bookmarkId from the URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const bookmarkId = urlParams.get('bookmarkId');
  // return if no bookmark
  if (!bookmarkId) return;
  // fetch content from bookmark
  try {
    const result = await client.graphql({
      query: getBookmark,
      variables: { id: bookmarkId },
      authMode: authMode
    });
    if (result.data && result.data.getBookmark) {
      const bookmark = result.data.getBookmark;
      return bookmark;
    }
  } catch (err) {
    console.log("Error occurred fetching bookmark from server. ", err);
    return;
  }
}

export default fetchBookmark;